<template>
    <div id="minicart" >
        <div class="inner">
            <div id="ssq-minicart" class="placeholder">
                <h2>Cart</h2>
                <div id="ssq-minicart-view">        
                <div class="ssq-minicart-loading"><p>Loading <a href="https://test.smartservice.qld.gov.au/payment/cart/view">cart</a>...</p></div>
                </div>

                <img src="https://test.smartservice.qld.gov.au/payment/minicart/synchronise?cartId=7b3b101e-4719-4064-a41a-e8c5b3a07ba3" id="ssq-synch-img" height="0" width="0" alt="" />
                <div class="ssq-minicart-cards">
                <h3>Cards accepted</h3>
                <ul>
                    <li><img src="https://test.smartservice.qld.gov.au/payment/minicart/visa.png" alt="Visa" /></li>
                    <li><img src="https://test.smartservice.qld.gov.au/payment/minicart/mastercard.png" alt="MasterCard" /></li>
                </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        let minicartScript = document.createElement('script')
        minicartScript.setAttribute('src', 'https://test.smartservice.qld.gov.au/payment/ui/minicart_1.0.js')
        document.body.appendChild(minicartScript)
    }
}
</script>
